/**
 * Thrown by the session API functions for any non-2xx response or
 * transport failure. `status` is `null` for transport-level errors.
 */
export class AuthApiError extends Error {
  readonly status: number | null;
  readonly upstreamMessage: string | undefined;

  constructor(
    message: string,
    options: { status?: number | null; upstreamMessage?: string } = {}
  ) {
    super(message);
    this.name = "AuthApiError";
    this.status = options.status ?? null;
    this.upstreamMessage = options.upstreamMessage;
  }
}

/**
 * Thrown by `refreshSession` when the refresh token itself is rejected
 * (4xx). Callers should clear local tokens and surface the session-expired
 * modal — no retry.
 */
export class RefreshFailedError extends AuthApiError {
  constructor(status: number, upstreamMessage?: string) {
    super("Session refresh failed — refresh token rejected", {
      status,
      upstreamMessage,
    });
    this.name = "RefreshFailedError";
  }
}
